import * as React from "react";
import { IPatientRedFlag } from "@curefit/ehr-common";
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import {PatientRedFlagsEditorProps} from "../../components/patient/edit/PatientRedFlagsEditor";
import {PatientRedFlagsViewProps} from "../../components/patient/view/PatientRedFlagsView";
import {SourceConstants} from "../../utils/AppConstants";
import IEditedBy from "../../models/IEditedBy";
import ModelFactory from "../../models/ModelFactory";
import {ITypeFormQuestionnaire} from "../../models/ITypeFormQuestionnaire";

/**
 * Created by aditya on 28/02/18.
 */

export interface RedFlagsEditViewContProps {
    appointmentId?: number,
    editedBy?: IEditedBy,
    patientId: number,
    displayMode?: EditViewDisplayMode,
    staticRedFlags: IStaticDataValue[],
    patientRedFlags: IPatientRedFlag,
    fetchPatientRedFlags?: (patientId: number) => any,
    savePatientRedFlags?: (patientId: number, patientRedFlags: IPatientRedFlag[]) => any,
    questionnaire?: ITypeFormQuestionnaire[];
    typeFormMapping?: any;
}


export interface RedFlagsEditViewContState {
    updatedRedFlags: IRedFlag,
    isPatientRedFlagsDataLoaded: LOADING_STATE
}

class RedFlagsEditViewCont extends React.Component<RedFlagsEditViewContProps, RedFlagsEditViewContState> {

    constructor(props: RedFlagsEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: RedFlagsEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedRedFlagsFromProps = (props: RedFlagsEditViewContProps): IRedFlag => {
        if (props.patientRedFlags !== null) {
            return props.patientRedFlags;
        } else return ModelFactory.createNewRedFlag();
    }

    getStateFromProps = (props: RedFlagsEditViewContProps) => {
        let currState: RedFlagsEditViewContState = {
            updatedRedFlags: {},
            isPatientRedFlagsDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( !_.isNull(props.patientRedFlags) && _.isNull(props.patientRedFlags.troubles) ) {
            props.fetchPatientRedFlags(this.props.patientId);
            currState.isPatientRedFlagsDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedRedFlags = this.getUpdatedRedFlagsFromProps(props);
            currState.isPatientRedFlagsDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getRedFlagsEditViewTemplateProps = () => {
        let patientRedFlagsViewProps: PatientRedFlagsViewProps = {
            allRedFlags: this.props.staticRedFlags,
            selectedRedFlags: this.state.updatedRedFlags,
        }
        let patientRedFlagsEditorProps: PatientRedFlagsEditorProps = {
            allRedFlags: this.props.staticRedFlags,
            selectedRedFlags: this.state.updatedRedFlags,
            updateRedFlags: this.updatePatientRedFlags
        }
        return {"view": patientRedFlagsViewProps, "edit": patientRedFlagsEditorProps};
    }

    updatePatientRedFlags = (updatedRedFlags: IRedFlag) => {
        this.setState({updatedRedFlags: updatedRedFlags});
    }

    savePatientRedFlags = () => {
        let myInstance = this;
        let saveRedFlagsList: IRedFlag[] = this.getSaveObject();
        if (saveRedFlagsList !== undefined) {
            this.setState({isPatientRedFlagsDataLoaded: LOADING_STATE.NOT_INITIALIZED});
            this.props.savePatientRedFlags(this.props.patientId, saveRedFlagsList).then(function(){
                myInstance.setState({isPatientRedFlagsDataLoaded: LOADING_STATE.LOADED});
            });
        }
    }

    getSaveObject = (): IRedFlag[] => {
        let redFlags: IRedFlag = this.state.updatedRedFlags;
        if (redFlags !== null && !_.isEmpty(redFlags)) {
            redFlags = AppUtils.sanitizeRequestItemBeforeSave(redFlags);
            if (redFlags.troubles === null) redFlags.troubles = [];
            redFlags.source = SourceConstants.DOCSASPP;
            redFlags.lastEditedPersonId = parseInt(this.props.editedBy.id);
            redFlags.personType = this.props.editedBy.role.toLowerCase();
            redFlags.appointmentId = this.props.appointmentId;
            redFlags.patientId = this.props.patientId;
            redFlags.isDeleted = false;
        }
        return [redFlags];
    }

    cancelActionHandler = () => {
        this.setState({updatedRedFlags: this.getUpdatedRedFlagsFromProps(this.props)});
    }

    render() {
        let isSurgeryDataLoaded =  this.state.isPatientRedFlagsDataLoaded === LOADING_STATE.LOADED;
        return (
            <div>
                {
                    isSurgeryDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Red Flags"} templateName={"redFlags"}
                                  templateProps={this.getRedFlagsEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientRedFlags}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode}
                    />
                }
                {
                    !isSurgeryDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default RedFlagsEditViewCont